<template>
  <div class="page"></div>
</template>
<script>
import { mapActions } from "vuex";
import { STATUS_CODE_OK, UIS_AUTH_URL } from "@/config";
import { codeToOpenId } from '@/api/common'
export default {
  name: "WxAuth",
  async created() {
    const that = this
    that.toast = that.$toast.loading({
      duration: 0,
      forbidClick: true,
      message: '授权登录中'
    })
    const { code, state = '/' } = that.$route.query
    if (code) {
      const { data } = await codeToOpenId({
        code: code
      })
      if (data.code === STATUS_CODE_OK) {
        const openId = data.data.openId
        that.setOpenId(openId);
        window.location.replace(
          `${UIS_AUTH_URL}&path=${window.encodeURIComponent(
            state
          )}&openId=${openId}&authScene=INDEX_AUTO_AUTH`
        );
      }
    }
  },
  methods: {
    ...mapActions(["setOpenId"]),
  },
  beforeDestroy() {
    this.toast && this.toast.clear(true)
  },
};
</script>

<style scoped lang="scss">
</style>
